"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function About() {
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const textLines = [{
    type: "eyebrow",
    content: "Premium Craftsmanship"
  }, {
    type: "heading",
    content: null
  }, {
    type: "body",
    content: "At MetalLine Exteriors, we transform Calgary homes with precision-engineered metal roofing and architectural cladding. Every project is managed by our expert team to ensure lasting durability and modern aesthetic appeal."
  }, {
    type: "body",
    content: "From initial consultation to final installation, we prioritize quality materials and meticulous attention to detail, delivering exterior solutions that stand the test of time."
  }];
  return <section data-section-id="17872" id="abouthero" className="bg-background text-foreground min-h-[92vh] overflow-hidden ![padding:65px_0px_65px_0px]">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-22">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {}
          <div ref={imageRef} data-index={0} className="lg:col-span-7 lg:-ml-6 relative" style={{
          opacity: imageVisible ? 1 : 0,
          transform: imageVisible ? "scale(1)" : "scale(1.04)",
          transition: "opacity 1200ms ease-out, transform 1800ms ease-out"
        }}>
            <div className="relative aspect-[5/6] md:aspect-[4/5] w-full overflow-hidden rounded-lg shadow-lg">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713190/img/metalline_roofing_specialist_ladder.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713190/img/metalline_roofing_specialist_ladder.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713190/img/metalline_roofing_specialist_ladder.webp-wvc-sizes" alt="MetalLine Exteriors roofing specialist on ladder with metal roofing installation" loading="eager" fetchPriority="high" decoding="async" className="h-full w-full object-cover" />
            </div>
          </div>

          {}
          <div ref={textRef} className="lg:col-span-5 lg:pl-8 xl:pl-16">
            <div className="flex flex-col">
              {textLines.map((line, i) => {
              const baseStyle = {
                opacity: textVisible ? 1 : 0,
                transform: textVisible ? "translateY(0px)" : "translateY(12px)",
                transition: `opacity 900ms cubic-bezier(0.22, 1, 0.36, 1) ${i * 80}ms, transform 900ms cubic-bezier(0.22, 1, 0.36, 1) ${i * 80}ms`
              };
              if (line.type === "eyebrow") {
                return <div key={i} data-index={i} style={baseStyle} className="font-default text-xs uppercase tracking-[0.18em] text-primary font-medium">
                      {line.content}
                    </div>;
              }
              if (line.type === "heading") {
                return <h1 key={i} data-index={i} style={baseStyle} className="font-default font-bold text-foreground mt-10 leading-[1.05] tracking-[-0.015em]">
                      <span className="block text-[clamp(2.25rem,4.2vw,4.25rem)]">
                        Elevating your
                      </span>
                      <span className="block text-[clamp(2.25rem,4.2vw,4.25rem)]">
                        <em className="font-default italic font-light">home's</em> exterior.
                      </span>
                    </h1>;
              }
              if (line.type === "body") {
                return <p key={i} data-index={i} style={baseStyle} className="font-default text-foreground/80 text-[clamp(1rem,1.1vw,1.125rem)] leading-[1.65] font-light mt-10 max-w-[44ch]">
                      {line.content}
                    </p>;
              }
              return null;
            })}
              
              <div data-index={textLines.length} className="mt-12" style={{
              opacity: textVisible ? 1 : 0,
              transform: textVisible ? "translateY(0px)" : "translateY(12px)",
              transition: `opacity 900ms cubic-bezier(0.22, 1, 0.36, 1) ${textLines.length * 80}ms, transform 900ms cubic-bezier(0.22, 1, 0.36, 1) ${textLines.length * 80}ms`
            }}>
                <Link to="/ContactPage">
                  <Button size="lg" className="bg-primary text-primary-foreground rounded-md px-8 py-6 text-base font-semibold hover:bg-primary/90 transition-colors">
                    Contact Us
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}